<template>
  <v-app>
    <v-container fluid>
      <site-menu-toolbar/>
      <v-main>
        <slot/>
      </v-main>
    </v-container>
  </v-app>
</template>

<script>
import SiteMenuToolbar from "@/components/SiteMenuToolbar";
export default {
  name: "SiteLayoutPlain",
  components: {
    SiteMenuToolbar,
  }
};
</script>

